import { CounterBadge, Grid, ModalV2, Text, Flex } from "@jsq/ds/core";
import { LinkedPositionsInfo } from "../../../types";
import { columnDefinition, defaultColDef, gridOptions } from "./gridConfig";
import { gridWrapper, modalBody, positionsCounterBadge } from "./styles_vanilla.css";

type ProfilePositionsModalProps = {
  profileName: string;
  positionCount: number;
  linkedPositions: LinkedPositionsInfo[];
  closeModal: () => void;
};

const ProfilePositionsModal = ({
  profileName,
  positionCount,
  linkedPositions,
  closeModal,
}: ProfilePositionsModalProps) => {
  return (
    <ModalV2
      data-testid="profile-positions-modal"
      show={true}
      title={profileName}
      onHide={closeModal}
      size="large"
    >
      <ModalV2.Body>
        <Flex className={modalBody} flexDirection="row" gap={4} alignItems={"center"}>
          <Text variant="secondary-md">Positions this profile is already associated with</Text>
          <CounterBadge
            className={positionsCounterBadge}
            count={positionCount}
            variant="neutral"
            border="dark"
          />
        </Flex>
        <div className={gridWrapper}>
          <Grid
            gridOptions={gridOptions}
            defaultColDef={defaultColDef}
            columnDefs={columnDefinition}
            rowData={linkedPositions}
          />
        </div>
      </ModalV2.Body>
    </ModalV2>
  );
};

export default ProfilePositionsModal;
